import renderResource from '../resource/render-resource'

import createWidgetArea from '../widget/widget-area'
import creatLayoutWidgets from './lib/layout-widgets'

import creatSectionLayoutWidgets from '../section/lib/layout-widgets'
import widgetDefaultParams from '../section/lib/widget-default-params'
import buildDefaultParameters from '../section/lib/build-query'

const widgetArea = `
${createWidgetArea([...creatSectionLayoutWidgets(), ...creatLayoutWidgets()])}
`

const createQuery = () => {
  const query = `...on Company {
    _id
    name
    slug
    shortDescription
    description
    linkedinId
    website
    emailAddress
    aiMeta {
      label
      value
    }
    latestContent {
      _id
      headline
      fullUrlPath
      category
    }
    entitySection {
      _id
      name
      slug
      fullUrlPath
      metaTitle
      metaDescription
      shareTitle
      shareDescription
      advertSectionId
        keyValueTargeting {
        key
        value
      }
      layouts {
        company {
          layout {
            attributes
            cols {
              width
              widgetArea {
                ${widgetArea}
              }
            }
          }
        }
      }
    }
    images {
      logo_free_127 {
        url
      }
      thumbnail_1x1_220 {
        url
      }
      thumbnail_1x1_576 {
        url
      }
      thumbnail_1x1_720 {
        url
      }
      thumbnail_1x1_900 {
        url
      }
    }
  }`
  return renderResource(
    query,
    buildDefaultParameters(query, widgetDefaultParams)
  )
}

export default createQuery
